var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubble11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 267,
    viewBox: "0 0 94 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2601 104.719C29.9433 70.6701 4.97559 24.7167 32.3411 5.54895C59.6387 -13.5713 89.3118 26.3668 119.235 38.1952C141.592 47.0327 167.909 45.8336 183.186 65.1769C200.318 86.8685 212.563 117.378 203.351 144.7C194.515 170.904 161.019 172.425 140.936 190.481C114.065 214.64 103.005 266.298 68.3647 266.061C33.8917 265.826 11.1943 224.512 1.63173 189.53C-6.26194 160.654 19.2527 134.718 24.2601 104.719Z",
    fill: "url(#paint0_linear_1419_96)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1419_96",
    x1: 71.1222,
    y1: 267.664,
    x2: 127.003,
    y2: 17.3518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D31027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA384D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble11);
export default __webpack_public_path__ + "static/media/bubble_11.611a2c11899d6a54ac649acb990f38d3.svg";
export { ForwardRef as ReactComponent };